import packageInfo from '../../package.json';

export const environment = {
  production: true,
  version: packageInfo.version,
  apiServerUrl: 'https://api.circlecart.app',
  apiClientId: 'TechieTechWeb',
  localStorageToken: 'token',
  localStorageRefreshToken: 'refreshToken',
  localStorageUserInfo: 'userInfo',
  supportedLanguages: 'en,de',
  alarmReloadInterval: 2000,
  idleTimeoutInSeconds: 300,
  localStorageActivityTimestamp: 'activityTimestamp',
  allowBrowserTranslation: true,
  
};
